<span mat-dialog-title class="title-medium on-surface-text"> Members </span>

<div mat-dialog-content>
  <mat-action-list disableRipple>
    @for (member of $members(); track member.resourceName) {
      <button mat-list-item (click)="navigateToProfile(member)">
        <user-avatar
          matListItemAvatar
          class="user-avatar"
          [userResourceName]="member.resourceName"
        >
        </user-avatar>
        <div matListItemTitle>{{ member.displayName }}</div>
        @if ($isOwner() && $appUser().resourceName !== member.resourceName) {
          <button
            mat-button
            matListItemMeta
            (click)="removePuebloMember(member, $event)"
          >
            Remove
          </button>
        }
      </button>
    }
  </mat-action-list>
</div>
